export const site = {
  name: "回声墙",
  fullName: "回声墙 · 网暴黑料亲历者档案",
  slogan: "让每一个被「黑料」围猎的人，被听见",
  intro:
    "回声墙是一个关注网络暴力受害者处境的纪实内容平台。我们记录当事人遭遇言语攻击、人肉搜索与精神创伤的真实过程，也整理心理影响分析与求助路径，希望让「网暴黑料」不再只是围观者的谈资，而是可以被理解、被修复的伤害。",
  email: "contact@huishengqiang.org",
  helpEmail: "support@huishengqiang.org",
  foundedYear: 2023,
  location: "线上内容平台 · 面向中文读者",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "亲述档案", to: "/stories" },
  { label: "伤害与恢复", to: "/knowledge" },
  { label: "关于我们", to: "/about" },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=moody%20conceptual%20editorial%20photography%20of%20an%20empty%20windswept%20corridor%20with%20rows%20of%20closed%20doors%2C%20warm%20amber%20light%20seeping%20through%20the%20cracks%2C%20long%20shadow%20of%20a%20lone%20unseen%20figure%2C%20heavy%20fog%2C%20desaturated%20rust%20and%20charcoal%20palette%2C%20cinematic%20depth%2C%20fine%20film%20grain%2C%20large%20dark%20negative%20space%20for%20headline%20text&width=1600&height=900&seq=huisheng-hero-01&orientation=landscape";

export const aboutImage =
  "https://readdy.ai/api/search-image?query=quiet%20editorial%20still%20life%20of%20a%20warm%20wooden%20desk%20with%20a%20closed%20notebook%2C%20a%20cup%20of%20tea%20and%20a%20small%20brass%20lamp%20casting%20amber%20light%2C%20soft%20morning%20mist%20through%20the%20window%2C%20desaturated%20rust%20and%20cream%20tones%2C%20calm%20documentary%20atmosphere%2C%20fine%20film%20grain%2C%20no%20people&width=1200&height=800&seq=huisheng-about-01&orientation=landscape";

export const stats = [
  { value: "68%", label: "的受访亲历者表示，黑料出现后一周内出现持续失眠与心悸" },
  { value: "41%", label: "曾遭遇不同程度的人肉搜索，真实身份被公开传播" },
  { value: "9.6 天", label: "平均从被围攻到第一次主动向外求助的间隔时间" },
  { value: "73%", label: "认为最难承受的不是谩骂，而是现实关系被牵连" },
];

export const harmTypes = [
  {
    icon: "ri-chat-delete-line",
    name: "言语围攻",
    desc: "短时间内大量侮辱、诅咒与嘲讽涌入评论区与私信，音量本身成为压力。",
  },
  {
    icon: "ri-user-location-line",
    name: "人肉搜索",
    desc: "真实姓名、住址、单位与家人信息被公开，线上攻击直接穿透到现实生活。",
  },
  {
    icon: "ri-scissors-cut-line",
    name: "恶意剪辑",
    desc: "断章取义的截图、录音与视频被拼贴成所谓「证据」，上下文被整体抽走。",
  },
  {
    icon: "ri-article-line",
    name: "造谣诽谤",
    desc: "凭空编造的私生活与经济纠纷被包装成「实锤」，重复到让人开始自我怀疑。",
  },
  {
    icon: "ri-flag-2-line",
    name: "举报封禁",
    desc: "有组织地反复举报，导致账号、店铺或作品被下架，生计随之被切断。",
  },
  {
    icon: "ri-links-line",
    name: "舆论株连",
    desc: "与当事人有往来的亲友、同事与合作方被一并攻击，社交圈被迫收缩。",
  },
];

export const recoverySteps = [
  {
    step: "01",
    title: "停止围观",
    desc: "停止反复刷新评论区与搜索自己的名字。每刷新一次，都相当于重新经历一次伤害。",
  },
  {
    step: "02",
    title: "保存证据",
    desc: "对攻击内容截图、录屏并记录时间与账号，必要时做证据公证，为后续举报与维权留底。",
  },
  {
    step: "03",
    title: "建立支持",
    desc: "找到至少一个可以信任的人，把发生的事完整说出来。被听见，是恢复的第一个转折点。",
  },
  {
    step: "04",
    title: "寻求专业介入",
    desc: "当情绪持续低落、无法入睡时，尽早联系心理咨询；涉及人身威胁时同步寻求法律帮助。",
  },
  {
    step: "05",
    title: "重建生活边界",
    desc: "逐步恢复作息与线下关系，允许自己「恢复得很慢」，把评价权一点点收回自己手里。",
  },
];

export const faqs = [
  {
    q: "被挂上「黑料」之后，第一件事应该做什么？",
    a: "先稳住呼吸，把情绪和行动分开。不要急着逐条对线或自证，先完整保存证据——包括发布链接、账号、时间和你受到的影响记录。证据决定了你后续能否举报成功或依法维权，而情绪化的回复往往会被二次剪辑利用。",
  },
  {
    q: "为什么当事人常常选择沉默，而不是澄清？",
    a: "因为澄清需要被相信。当舆论已经形成预设结论时，解释很容易被解读为「狡辩」，反而制造新的话题点。加上人肉搜索带来的现实风险，沉默往往是当事人在权衡安全之后做出的无奈选择，而不是心虚。",
  },
  {
    q: "网络暴力真的会造成长期心理伤害吗？",
    a: "会。持续的网络攻击可能引发急性应激反应、焦虑、抑郁与睡眠障碍，也可能让人对社交场合产生回避。与线下冲突不同的是，网络攻击没有明确的结束时间，也几乎无法知道施暴者是谁，这种不确定性会显著延长痛苦的持续时间。",
  },
  {
    q: "亲友被牵连进来，我应该怎么面对他们？",
    a: "第一时间如实说明情况，而不是替他们做决定隐瞒。可以一起商定统一的应对口径：不转述、不回应、不扩大。要理解他们也会恐慌，这个阶段彼此都需要被安抚，而不是互相责怪。",
  },
  {
    q: "当事人可以怎么维权，需要准备什么？",
    a: "常见路径包括向平台投诉要求删除与封禁、向公安机关报案（涉及侮辱、诽谤、威胁或隐私泄露）、以及通过民事诉讼要求停止侵害与赔偿。准备材料上，最关键是完整的证据链，包括内容截图、链接、发布者信息以及伤害后果的记录。",
  },
  {
    q: "围观者在这样的传播链里可以做什么？",
    a: "最有效的事情是「不转发、不补充、不点评」。如果不确定真假，就不要成为传播节点；如果发现明确的隐私泄露或人身威胁，可以协助举报。对当事人而言，少一个转发的账号，就少一次扩散。",
  },
  {
    q: "恢复需要多久，有没有一个标准？",
    a: "没有统一标准。有人几周就能回到往常节奏，也有人需要一年以上。恢复不是「忘记」，而是当这类话题再次出现时，你能不再被瞬间拽回当时的处境。允许反复，本身也是恢复的一部分。",
  },
  {
    q: "回声墙会公开当事人的真实身份吗？",
    a: "不会。平台收录的所有亲述均以化名呈现，并对可识别身份的信息做模糊处理。我们在征得当事人同意后才会刊发，并保留随时撤下的权利。",
  },
];

export const testimonials = [
  {
    name: "林姓读者",
    role: "曾经历人肉搜索",
    text: "看到有人把「被挂」之后的心理变化写得那么细，我第一次觉得自己不是矫情。原来反复失眠、害怕接陌生电话，都是正常的应激反应。",
  },
  {
    name: "程老师",
    role: "中学教师",
    text: "我把这里的恢复路径整理成了班会材料。学生不一定经历过网暴，但几乎都围观过，知道伤害是怎么发生的很重要。",
  },
  {
    name: "周社工",
    role: "社区心理援助志愿者",
    text: "内容不煽情，也不急着给结论，这点很难得。求助指引写得具体，转给来咨询的当事人时，他们看得进去。",
  },
];

export const contact = {
  email: site.email,
  helpEmail: site.helpEmail,
  responseTime: "来信我们通常在 2 个工作日内回复",
  note: "如果你是正在经历网络暴力的当事人，请优先前往「伤害与恢复」页面查看紧急求助指引。",
};